// components/views/profile/QuickBooksSetup.jsx
import React, { Component } from 'react';
import QboAPI from '../../../services/qboService';

class QuickBooksSetup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: null
    };
  }

  handleEnable = async () => {
    this.setState({ loading: true, error: null });
    try {
      await QboAPI.enable(this.props.installer.Installer_id);
      if (this.props.onStatusChange) this.props.onStatusChange();
    } catch (error) {
      console.error('QBO enable error:', error);
      this.setState({
        loading: false,
        error: error.response?.data?.message || 'Failed to enable QuickBooks'
      });
    }
  };

  handleConnect = async () => {
    this.setState({ loading: true, error: null });
    try {
      const response = await QboAPI.getAuthUri(this.props.installer.Installer_id);
      if (response.authUri) {
        window.location.href = response.authUri;
      } else {
        throw new Error('Failed to get QuickBooks authorization link');
      }
    } catch (error) {
      console.error('QBO connect error:', error);
      this.setState({
        loading: false,
        error: error.response?.data?.message || 'Failed to connect to QuickBooks'
      });
    }
  };

  render() {
    const { installer, qbo } = this.props;
    const { loading, error } = this.state;

    if (!installer) {
      return (
        <div className="alert alert-warning">
          <p className="mb-0">Unable to load account information. Please refresh the page.</p>
        </div>
      );
    }

    const isEnabled = qbo && qbo.enabled;
    const isConnected = isEnabled && qbo.connected;

    // ── Connected ──────────────────────────────────────────────────
    if (isConnected) {
      return (
        <div className="qbo-setup-complete">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <span className="badge badge-success mr-2">
                <i className="fa-sharp fa-regular fa-check mr-1"></i> Connected
              </span>
              <span className="text-muted">Your QuickBooks account is linked</span>
            </div>
          </div>

          {qbo.last_sync_at && (
            <div className="mt-2">
              <small className="text-muted">
                <i className="fa-sharp fa-regular fa-clock mr-1"></i>
                Last synced: {new Date(qbo.last_sync_at).toLocaleString()}
              </small>
            </div>
          )}

          {error && (
            <div className="alert alert-danger mt-2 mb-0">
              <small>{error}</small>
            </div>
          )}
        </div>
      );
    }

    // ── Enabled but not connected ──────────────────────────────────
    if (isEnabled && !isConnected) {
      return (
        <div className="qbo-setup-required">
          <div className="alert alert-info mb-3">
            <div className="d-flex align-items-center">
              <div className="mr-3">
                <div className="bg-info text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                  <i className="fa-sharp fa-regular fa-link"></i>
                </div>
              </div>
              <div>
                <h6 className="alert-heading mb-1">Connect Your QuickBooks Account</h6>
                <p className="mb-0">Link your QuickBooks Online account to automatically sync invoices and payments.</p>
              </div>
            </div>
          </div>

          {error && (
            <div className="alert alert-danger">
              <small>{error}</small>
            </div>
          )}

          <div className="row mb-3">
            <div className="col-md-6">
              <h6>What Gets Synced</h6>
              <ul className="list-unstyled">
                <li><i className="fa-sharp fa-regular fa-check text-success mr-1"></i> Invoices</li>
                <li><i className="fa-sharp fa-regular fa-check text-success mr-1"></i> Payments received</li>
                <li><i className="fa-sharp fa-regular fa-check text-success mr-1"></i> Customer records</li>
              </ul>
            </div>
            <div className="col-md-6">
              <h6>How It Works</h6>
              <ul className="list-unstyled">
                <li><i className="fa-sharp fa-regular fa-shield-check text-primary mr-1"></i> Secure OAuth connection</li>
                <li><i className="fa-sharp fa-regular fa-arrows-rotate text-primary mr-1"></i> Automatic sync on payment</li>
                <li><i className="fa-sharp fa-regular fa-plug text-primary mr-1"></i> Disconnect anytime</li>
              </ul>
            </div>
          </div>

          <div className="text-center">
            <button
              className="btn btn-success btn-lg"
              onClick={this.handleConnect}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-2" role="status"></span>
                  Connecting...
                </>
              ) : (
                <>
                  <i className="fa-sharp fa-regular fa-link mr-2"></i>
                  Connect QuickBooks
                </>
              )}
            </button>
            <p className="text-muted mt-2 small">
              You'll be redirected to Intuit to authorize access
            </p>
          </div>
        </div>
      );
    }

    // ── Not enabled ────────────────────────────────────────────────
    return (
      <div className="qbo-setup-disabled">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <p className="mb-1 text-muted">
              Sync your invoices and payments directly to QuickBooks Online.
            </p>
          </div>
          <button
            className="btn btn-outline-success btn-sm"
            onClick={this.handleEnable}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm mr-1" role="status"></span>
                Enabling...
              </>
            ) : (
              'Enable QuickBooks'
            )}
          </button>
        </div>

        {error && (
          <div className="alert alert-danger mt-2 mb-0">
            <small>{error}</small>
          </div>
        )}
      </div>
    );
  }
}

export default QuickBooksSetup;
